<div class="email-confirmation-flow">
  <div class="row">
    <div class="col-12">
      <div class="subheading">
        <p class="info-text"><adp-label labelKey="Signup_NewUser_ConfirmEmail_Body_Text"></adp-label></p>
        <p class="font-weight-bold email-contract"> {{ emailAddress }} </p>
      </div>
    </div>
  </div>
  <div class="row pt-3 pb-3">
    <div class="col-12 justify-content-center">
      <div class="form-group">
        <button mat-flat-button color="accent"
          (click)="onNextEmailFlow()"><adp-label labelKey="Signup_NewUser_ConfirmEmail_SubmitButton_Text"></adp-label></button>
      </div>
    </div>
  </div>
  <div class="row pt-3 pb-3">
    <adp-label class="footer-text col-12" labelKey="Signup_ChangeEmail_Text"></adp-label>
  </div>
</div>